import { ListPage } from "@/archetypes/ListPage";
import { DataGrid, type DataGridColumn } from "@/components/data-grid";
import { IntentButton } from "@/components/intent-button";

interface Sample { id: number; name: string; total: number; }
const sampleRows: Sample[] = Array.from({ length: 25 }, (_, i) => ({
  id: i + 1, name: `Sample ${i + 1}`, total: (i + 1) * 1000,
}));
const cols: DataGridColumn<Sample>[] = [
  { id: "id", header: "ID", accessor: (r) => r.id, width: "80px" },
  { id: "name", header: "Name", accessor: (r) => r.name, sortable: true },
  { id: "total", header: "Total", accessor: (r) => `$${r.total.toLocaleString()}`, align: "right" },
];

export function ReferenceListPage() {
  return (
    <ListPage title="Reference list" primaryAction={<IntentButton>New</IntentButton>}>
      <DataGrid
        rows={sampleRows.slice(0, 20)}
        columns={cols}
        rowKey={(r) => r.id}
        totalRows={sampleRows.length}
        pageIndex={0}
        pageSize={20}
        onPageChange={() => {}}
      />
    </ListPage>
  );
}
